import * as React from 'react';

interface IProps {
  className?: string;
  width?: number;
  height?: number;
}

export const DefaultImg: React.FC<IProps> = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 80 80"
    >
      <rect width="100%" height="100%" fill="#fff" rx="4" />
      <rect width="100%" height="100%" fill="#152242" fillOpacity="0.06" rx="4" />
      <path
        fill="#CED1D7"
        fillRule="evenodd"
        d="M35.742 20.684a3.921 3.921 0 014.43-3.338l17.475 2.456a3.922 3.922 0 013.337 4.43L57.982 45.59a3.922 3.922 0 01-4.429 3.337l-3.083-.433-1.11-8.076 5.285.743L57.1 23.685 39.626 21.23l-.567 4.031-4.047.618.73-5.194zM20.45 31.834a2 2 0 00-1.702 2.26l3.537 25.164a2 2 0 002.259 1.702l21.28-2.99a2 2 0 001.703-2.26L43.99 30.546a2 2 0 00-2.259-1.702l-21.28 2.99zm5.21 9.169a1.96 1.96 0 10-.546-3.884 1.96 1.96 0 00.545 3.884zm15.806-.242l1.637 11.65-4.37.614h.001l-13.106 1.842 5.57-7.91 3.768 3.034 6.5-9.23z"
        clipRule="evenodd"
      />
    </svg>
  );
};
